<p-dialog [header]="'Update'" [visible]="visible" [style]="{width: '30vw'}" (visibleChange)="hide()">
  <div class="datagrid-form">
    <div class="datagrid__fields">
      <div class="form-field-box">
        <label for="title-input">View Name</label>
        <input [(ngModel)]="tempView.name" type="text" id="title-input" name="title" placeholder="Name">
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button (click)="cancel($event)" type="button" class="btn-bg"  data-dismiss="modal">Cancel</button>
    <button [disabled]="!tempView.name || tempView.name.length > 50" (click)="update($event)" type="button" class="btn-bg">Update</button>
  </ng-template>
</p-dialog>